module.exports = __webpack_public_path__ + "media/images/MyEtherWallet-00653479.svg";